import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BodyComponent} from './body/body.component';
import {StudiumDetailComponent} from './studium-detail/studium-detail.component';
import {ZalozkaObsahComponent} from './zalozka-obsah/zalozka-obsah.component';
import {AppComponent} from './app.component';
import {DotaznikyComponent} from './dotazniky/dotazniky.component';

const routes: Routes = [
  {path: '', component: BodyComponent },
  {path: 'studium', component: StudiumDetailComponent },
  {path: 'dotazniky', component: DotaznikyComponent },
  {path: 'zalozka/:id', component: ZalozkaObsahComponent },
  {path: 'auth-error', component: AppComponent},
  {path: '**', component: BodyComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
